import React, { FC } from 'react';
import { I18n, useSeoDefaults } from '@funtech-int/yango-shared';
import type {
    PlayerMetaEpisode,
    PlayerMetaFilm,
} from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { useI18n } from '@/shared/i18n/seo/useI18n';
import { presentTitle } from '@/shared/lib/movie';

interface Props {
    playerMeta: PlayerMetaFilm | PlayerMetaEpisode;
}

interface Params {
    i18n: I18n;
    playerMeta: PlayerMetaFilm | PlayerMetaEpisode;
    brandName: string;
}

function presentOttMovieSeoTitle({ i18n, playerMeta, brandName }: Params) {
    if (playerMeta.typename === 'Film') {
        const title = presentTitle(playerMeta.movieMeta.title);
        return title ? i18n('movie__film_seo_title', { title, brandName }) : brandName;
    }

    const title = presentTitle(playerMeta.tvSeriesMeta?.title);
    return title ? i18n('movie__series_seo_title', { title, brandName }) : brandName;
}

export const PlayerHead: FC<Props> = ({ playerMeta }) => {
    const i18n = useI18n();
    const { Head, seoSiteName } = useSeoDefaults();

    const movieSeoTitle = presentOttMovieSeoTitle({
        i18n,
        playerMeta,
        brandName: seoSiteName,
    });

    // TODO: https://st.yandex-team.ru/OTT-70390
    const title =
        movieSeoTitle || i18n('movie__film_seo_title', { title: '', brandName: seoSiteName });

    return (
        <Head>
            <title key="title">{title}</title>
        </Head>
    );
};
